import LTR from "@brand-icons/global/store-locator/store-locator-ltr.svg";

import { iconFactory } from "../iconFactory";

export const StoreLocatorIcon = iconFactory("StoreLocatorIcon", LTR);
